import ContentsToReact from '@/components/ContentsToReact/ContentsToReact';
import GenericModals from '@/components/GenericModals/GenericModals';
import Page from '@/components/Page/Page';
import PageHead from '@/components/PageHead/PageHead';
import { extractContents } from '@/helpers/extractContents';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import { transformLandingPageHeaderArea } from '@/helpers/transformLandingPageHeaderArea';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import type { PageModel } from '@/models/page';
import BackToTopButton from '@uikit/components/BackToTopButton/BackToTopButton';
import EnercityLandingPageFooter from '@uikit/components/EnercityLandingPageFooter/EnercityLandingPageFooter';
import EnercityLandingPageHeader from '@uikit/components/EnercityLandingPageHeader/EnercityLandingPageHeader';
import Layout from '@uikit/components/Layout/Layout';
import Modal from '@uikit/components/Modal/Modal';
import cmsComponents from './LandingPage.cmsComponents';
import type { LandingPageProps } from './types';

const LandingPage = (pageData: PageModel<LandingPageProps>) => {
  const meta = extractPageMetaFromRouteData(pageData);
  const { contents, modals, props } = pageData;
  const { showHeader = true, showFooter = true } = props;
  const {
    extractedContents: [headerArea, noticeBarArea],
    restContents,
  } = extractContents(['landing-page-header', 'notice-bar-area'], contents);

  useInitialPageDataLayer({ resourceType: 'detailpage' });

  return (
    <>
      <PageHead {...meta} />

      {noticeBarArea && (
        <ContentsToReact
          contents={noticeBarArea}
          cmsComponents={cmsComponents}
        />
      )}

      <Layout>
        {!!showHeader && (
          <EnercityLandingPageHeader
            {...transformLandingPageHeaderArea(headerArea)}
          />
        )}

        <Page>
          {restContents && (
            <ContentsToReact
              contents={restContents}
              cmsComponents={cmsComponents}
            />
          )}
        </Page>

        <BackToTopButton />

        {!!showFooter && <EnercityLandingPageFooter />}
      </Layout>

      <GenericModals
        modals={modals}
        modalComponent={Modal}
        cmsComponents={cmsComponents}
      />
    </>
  );
};

export default LandingPage;
